import SettingsExpertTeamDetailsEditModalModule from './team-details-edit-modal.module'

export default SettingsExpertTeamDetailsEditModalModule
